export default {
  报价管理: "Quản lý giá",
  样品管理: "Quản lý mẫu",
  脚本审核: "Kiểm duyệt script",
  草稿审核: "Kiểm duyệt bản nháp",
  交付内容: "Nội dung giao hàng",
  打款信息: "Thông tin thanh toán",
  商单PM: "Quản lý chiến dịch",
  "复制成功！": "Đã sao chép!",
  "商单已交付或已取消，不可操作，已为您刷新页面！":
    "Chiến dịch đã hoàn tất hoặc bị huỷ, không thể thao tác. Trang đã được làm mới",
  达人要求: "Yêu cầu creator",
  粉丝量: "Lượt theo dõi",
  目标接单达人数: "Số lượng creator nhận job",
  "平均预算/达人": "Giá trung bình/creator",
  目标总预算: "Tổng ngân sách",
  邀约达人时间: "Thời gian mời creator",
  目标交付时间: "Thời gian giao hàng",
  查看详情: "Xem chi tiết",
  邀约中: "Đang mời",
  已接单: "Đã nhận job",
  已取消: "Đã hủy",
  达人唯一名: "Tên creator duy nhất",
  达人昵称: "Tên creator",
  达人: "Creator",
  粉丝数: "Lượt theo dõi",
  邀约报价: "Giá mời hợp tác",
  操作: "Thao tác",
  修改报价: "Sửa giá",
  复制邀请链接: "Sao chép link mời",
  取消邀约: "Hủy mời",
  新增邀约达人: "Thêm creator",
  邀约达人: "Mời creator",
  已邀约达人不可重复添加: "Creator đã được mời, không thể thêm lại",
  请输入TikTok账号唯一名: "Nhập tên TikTok duy nhất",
  请输入金额: "Nhập số tiền",
  修改后达人的商单邀请将同步更新: "Lời mời sẽ được cập nhật sau khi chỉnh sửa",
  请输入取消邀约理由: "Nhập lý do hủy mời",
  "最多可输入100个字，请简短说说为什么。": "Tối đa 100 ký tự, vui lòng nêu ngắn gọn",
  "取消成功！": "Hủy thành công!",
  "修改成功！": "Sửa thành công!",
  "添加成功！": "Thêm thành công!",
  "达人已申请样品，不可取消接单！": "Creator đã xin mẫu, không thể hủy",
  导出数据: "Xuất dữ liệu",
  接单达人: "Creator nhận job",
  选择操作: "Chọn thao tác",
  修改最终报价: "Sửa giá cuối cùng",
  取消接单: "Hủy nhận job",
  新增接单达人: "Thêm creator đã nhận job",
  已接单达人不可重复添加: "Creator đã nhận, không thể thêm lại",
  "该达人已接单您的邀请，请勿重复添加！": "Creator đã nhận lời mời",
  接单报价: "Giá nhận job",
  "请和达人确认后修改，否则由PIC自行承担责任！":
    "Vui lòng xác nhận với creator trước khi sửa, PIC tự chịu trách nhiệm",
  最终报价: "Giá cuối cùng",
  请输入取消接单理由: "Nhập lý do hủy nhận job",
  接单时间: "Thời gian nhận job",
  取消时间: "Thời gian hủy",
  取消理由: "Lý do hủy",
  "自动取消，已被其他PIC谈成！": "Hủy tự động, đã được PIC khác chốt",
  商单已交付: "Chiến dịch đã giao",
  待申样: "Chờ xin mẫu",
  已申样: "Đã xin mẫu",
  申请样品: "Yêu cầu mẫu",
  商单: "Campaign",
  新建样品订单: "Tạo đơn hàng mẫu mới",
  报价: "Giá",
  申样达人名称: "Tên creator xin mẫu",
  可履约方式: "Cách thực hiện",
  "该达人粉丝数＜20K": "Creator có <20K follower",
  收件人姓名: "Tên người nhận",
  收件人电话: "Số điện thoại người nhận",
  地区: "Khu vực",
  详细地址: "Địa chỉ chi tiết",
  "请输入街道名称，公寓名称，房间号": "Nhập tên đường, tên căn hộ, số phòng",
  商单商品: "Sản phẩm",
  商品ID: "Mã sản phẩm",
  添加规格: "Thêm phân loại",
  规格: "Phân loại",
  数量: "Số lượng",
  请输入有效的手机号: "Vui lòng nhập số điện thoại hợp lệ",
  申样数量: "Số lượng xin mẫu",
  样品详情: "Chi tiết sản phẩm mẫu",
  追加申样: "Xin thêm mẫu",
  待审核: "Đang chờ duyệt",
  待发货: "Chờ gửi hàng",
  待履约: "Chờ thực hiện",
  已拒绝: "Đã từ chối",
  合格: "Đạt",
  不合格: "Không đạt",
  待上传: "Chờ tải lên",
  待收款: "Chờ thanh toán",
  已收款: "Đã thanh toán",
  交付视频: "Video giao hàng",
  标题: "Tiêu đề",
  Hashtag达标: "Hashtag đạt yêu cầu",
  挂链正确: "Link chính xác",
  时长达标: "Thời lượng đạt yêu cầu",
  "Ads Code": "Ads Code",
  播放量: "Lượt xem",
  "销量（TAP link）": "Doanh số（Gắn link sản phẩm）",
  校验人: "Người kiểm duyệt",
  系统自动: "Hệ thống tự động",
  人工校验: "Duyệt thủ công",
  其他理由: "Lý do khác",
  确认合格: "Xác nhận đạt",
  重新上传: "Tải lại video",
  确认商单商品合格: "Xác nhận sản phẩm đạt",
  "请勾选以下要求，人工确认已合格": "Vui lòng chọn các mục dưới đây để xác nhận đã đạt",
  Hashtag: "Hashtag",
  "TAP link": "Gắn link sản phẩm",
  视频时长: "Thời lượng video",
  交付视频合格: "Video đạt yêu cầu",
  "该视频将标记为合格视频，你还要继续吗？":
    '<span style="color: red">Video này sẽ được đánh dấu là đạt</span>. Bạn muốn tiếp tục không?',
  "请勾选以理由，将在APP展示给达人": "Hãy chọn lý do để hiển thị cho creator",
  Hashtag错误: "Hashtag sai",
  "TAP link未挂链": "TAP link chưa gắn",
  视频时长未达标: "Thời lượng video không đạt",
  "Ads Code未填或填写错误": "Ads Code chưa nhập hoặc sai",
  不超过20个字: "Tối đa 20 ký tự",
  不合格理由: "Lý do không đạt",
  "请输入该视频的Ads Code": "Nhập mã Ads Code cho video này",
  仅展示信息有误: "Thông tin hiển thị sai",
  履约状态: "Trạng thái thực hiện",
  已交付: "Đã giao",
  应付商单费用: "Số tiền phải trả",
  收款类型: "Loại thanh toán",
  未上传: "Chưa tải lên",
  信息有误: "Thông tin sai",
  个人: "Cá nhân",
  公司: "Công ty",
  银行信息: "Thông tin ngân hàng",
  收款人: "Người nhận",
  收款银行: "Ngân hàng",
  收款卡号: "Số tài khoản",
  查看凭证: "Xem bằng chứng",
  手机号: "Số điện thoại",
  身份证信息: "Thông tin CMND",
  姓名: "Tên",
  性别: "Giới tính",
  称呼: "Danh xưng",
  身份证号: "Số CMND",
  身份证居住地址: "Địa chỉ thường trú",
  营业执照: "Giấy phép kinh doanh",
  添加收款信息: "Thêm thông tin thanh toán",
  编辑收款信息: "Sửa thông tin thanh toán",
  "必填项未填！": "Thiếu thông tin bắt buộc!",
  个人收款: "Cá nhân",
  公司收款: "Công ty",
  收款信息: "Thông tin thanh toán",
  联系电话: "Số liên lạc",
  收款人性别: "Giới tính người nhận",
  小姐: "Cô",
  女士: "Chị",
  先生: "Anh",
  身份证姓名: "Tên trên CMND",
  请输入身份证居住地址: "Địa chỉ trong CMND",
  身份证号码: "Số CMND",
  银行卡号: "Ngân hàng",
  身份证照片: "Ảnh CMND",
  银行信息截图: "Ảnh chụp thông tin ngân hàng",
  确认通过: "Xác nhận duyệt",
  "确认收款信息无误可以打款，你还要继续吗？":
    '<span style="color: red">Xác nhận thông tin chính xác để thanh toán</span>, tiếp tục?',
  收款信息有误: "Thông tin thanh toán sai",
  "请填写理由，将在APP展示给达人": "Vui lòng nhập lý do, sẽ hiển thị trong app",
  不超过50个字: "Tối đa 50 ký tự",
  银行信息凭证: "Ảnh ngân hàng",
  银行凭证: "Ảnh ngân hàng",
  关闭: "Đóng",
  保存: "Lưu",
  居住地址: "Địa chỉ thường trú",
  "该信息已审核通过或已打款，不可保存修改内容":
    "Thông tin đã được duyệt hoặc đã thanh toán, không thể lưu",
  营业执照凭证: "Ảnh giấy phép kinh doanh",
  收款信息审核人: "Người kiểm duyệt thanh toán",
  导入数据: "Nhập dữ liệu",
  确认打款: "Xác nhận thanh toán",
  请输入打款时间: "Nhập thời gian thanh toán",
  打款时间: "Thời gian chuyển khoản",
  打款类型: "打款类型",
  打款操作人: "Người thanh toán",
  通过: "Được duyệt",
  已打款: "Đã thanh toán",
  系统审核中: "Đang kiểm duyệt",
  身份证凭证: "Ảnh CMND",
  修改收款信息: "Sửa thông tin thanh toán",
  公司营业执照: "Giấy phép công ty",
  收款人称呼: "Tên người nhận",
  进行中: "Đang thực hiện",
  "申样成功，请前往样品申样查看！": "Đã xin mẫu, vui lòng xem trong trang xin mẫu",
  前往样品申样: "Xem trong trang xin mẫu",
  "操作成功！": "Thành công!",
  请勾选所有要求: "Vui lòng chọn tất cả yêu cầu",
  必需: "Bắt buộc",
  非必需: "Không bắt buộc",
  商单报价: "Giá chiến dịch",
  VAT: "VAT",
  商单总价: "Tổng giá chiến dịch",
  含VAT: "Có VAT",
  WHT: "WHT",
  代扣税额: "Thuế phải trả",
  应打款金额: "Số tiền phải thanh toán",
  "Net Pay": "Net Pay",
  含税: "Có thuế",
  请输入有效的银行卡号: "Vui lòng nhập số tài khoản ngân hàng hợp lệ",
  请输入有效的身份证号: "Vui lòng nhập số CMND hợp lệ",
  已完成: "Đã hoàn thành",
  待打款: "Đang chờ thanh toán",
  总订单数: "Tổng đơn hàng",
  请人工校验: "Vui lòng kiểm tra thủ công",
  刷新: "Làm mới",
  成功商品数: "Số lượng sản phẩm thành công",
  失败商品数: "Số lượng sản phẩm thất bại",
  个税: "Thuế thu nhập",
  "不可打款-未履约": "Không thể thanh toán - Chưa hoàn thành",
  "可打款-已履约": "Có thể thanh toán - Đã hoàn thành"
};
